import { useContext } from 'react';

import { ApplicationContext } from '@App/contexts/Application';
import { DebtConContext } from '@src/app/contexts/DebtCon';
import EligibilityLayout from '@src/ui/layouts/EligibilityLayout';
import IntroView from '@src/ui/views/debtCon/IntroView';

const Intro = () => {
    const { loading } = useContext(ApplicationContext);

    const { loading: debtConLoading } = useContext(DebtConContext);

    return (
        <EligibilityLayout loading={loading || debtConLoading}>
            <IntroView />
        </EligibilityLayout>
    );
};

export default Intro;
